import AdminApplications from "../../components/Admin/AdminApplications";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import { applicationStageMap } from "../../config/applicationStatusConfig";

const CTTCApplications = () => {
  return (
    <DashboardLayout pageTitle="Application" mainClass="p-6">
      <AdminApplications
        title="SLAC Applications"
        status={[]}
        stage={[applicationStageMap?.slac.value]}
      />
    </DashboardLayout>
  );
};

export default CTTCApplications;
